import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

require('./pageHeader.css');

export type Props = {
    title: string;
    subTitle?: ReactNode;
    nestedTitle?: string;
    titleLink?: string;
    children?: ReactNode;
};

export const PageHeader = (props: Props) => {
    const { title, titleLink, nestedTitle, subTitle, children } = props;
    return (
        <header id="page-header">
            { !nestedTitle &&
                <h1>
                    { title }&nbsp;
                </h1>
            }
            { nestedTitle &&
                <h1>
                    <Link to={ titleLink! }>
                        { title }
                    </Link>
                    <i className="right angle icon"/>
                    <span>
                        { nestedTitle }
                    </span>
                </h1>
            }
            { subTitle &&
                <div className="sub-title">
                    { subTitle }
                </div>
            }
            <nav id="second-nav">
                { children }
            </nav>
        </header>
    );
};
